import React from 'react';

import './index.scss';

// eslint-disable-next-line react/prop-types
export default function BodyRegular({ children }) {
  return (
    <div className="body-regular">{ children }</div>
  );
}
